import axios from "axios";
export const getRedirectUrl = appId => {
  return axios.request({
    url: "/api/authz/cas/granting",
    method: "get",
    params: {
      appId
    },
    headers: {
      "x-iw-workbench": true
    }
  });
};
export const auth = redirect_uri => {
  return axios.request({
    url: "/api/authz/cas/auth",
    method: "get",
    params: {
      redirect_uri: decodeURIComponent(redirect_uri)
    }
  });
};
export const authzAppCode = appCode => {
  return axios.request({
    url: `/api/authz/api/${appCode}`,
    method: "get"
  });
};

//获取集团用户可登录的iHotel酒店列表
export const listHotels = search => {
  return axios.request({
    url: `/api/authz/iHotel/listHotels`,
    method: "get",
    params: {
      search
    }
  });
};
export const selectHotel = data => {
  return axios.request({
    url: `/api/authz/iHotel/selectHotel`,
    method: "post",
    data
  });
};